<template>
  <div class="custom-control custom-checkbox">
    <input
      type="checkbox"
      class="custom-control-input"
      :id="id"
      :checked="value"
      :disabled="disabled"
      @change="$emit('input', $event.target.checked)"
    >
    <label :class="['custom-control-label', 'mb-0', labelClass]" :for="id">
      <slot>{{ label }}</slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppCheckbox',
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: '' },
    id: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    labelClass: { type: [String, Array, Object], default: null }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppCheckbox.vue